import { produce } from 'immer';
import { entity } from 'simpler-state';

import { UserTypeRelation } from '../models/crm/types';

type dataType = {
  userTypeRelation: UserTypeRelation | null;
}

const INITIAL_STATE: dataType = { userTypeRelation: null };

const self = entity(INITIAL_STATE);

const setCustomerData = (value: typeof INITIAL_STATE): void => {
  self.set(
    produce(state => {
      state.userTypeRelation = value.userTypeRelation;
    }),
  );
};

export default {
  get: () => self.get(),
  setCustomerData,
};
